import { Role } from '@/constants/role.js'

export const state = {
    project: {
        projectName: '',
        projectUuid: '',
        roles: [],
    },
}

export const mutations = {
    SET_PROJECT(state, { project }) {
        state.project = project
    },
}

export const getters = {
    project(state) {
        return state.project
    },
    isOwner(state) {
        return state.project.roles[0] === Role.owner
    },
    isTranslator(state) {
        return state.project.roles[0] === Role.translator
    },
    isDeveloper(state) {
        return state.project.roles[0] === Role.developer
    },
    isAdmin(state) {
        return state.project.roles[0] === Role.admin
    },
}

export const actions = {
    setProject({ commit }, payload) {
        commit('SET_PROJECT', payload)
    },
}
